import { render, staticRenderFns } from "./WelfareHome.vue?vue&type=template&id=305144ac&scoped=true"
import script from "./WelfareHome.vue?vue&type=script&lang=js"
export * from "./WelfareHome.vue?vue&type=script&lang=js"
import style0 from "./WelfareHome.vue?vue&type=style&index=0&id=305144ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305144ac",
  null
  
)

export default component.exports